let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9t0qc")).then(() => parcelRequire('3ndEe'));